export const passwordCardDeleteModal = {
	confirmButton: "Yes, I want to block the password card",
	text:
		"In case of loss of a password card, it is advisable to block it. Upon confirming the block, your history is recorded, but it is no longer valid. Therefore, you want to block ",
	complement: {
		single: "the password card from {{cardName}}",
		multiple: "the selected password cards?",
	},
};
